import React, { useState } from 'react';
import clsx from 'clsx';
import style from './MobileMenuTab.module.scss';
export function MobileMenuTab({ button, children, buttonClassName, contentClassName, }) {
    const [isOpen, setIsOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: clsx(style.button, buttonClassName), onClick: () => setIsOpen(!isOpen), type: "button" }, button && button(isOpen)),
        isOpen && React.createElement("div", { className: contentClassName }, children)));
}
